export const colors = {
  primaryColor: "#D62221",
  secondaryColor: "#00aeef",
};
